/** @jsxRuntime classic */
/** @jsx jsx */
import { useState, forwardRef, useEffect } from 'react';
import { jsx } from '@emotion/core';
import sx from "../../../styles/sx";
const OptionWrapper = WrappedComponent => {
  return /*#__PURE__*/forwardRef((props, ref) => {
    const [options, setOptions] = useState({});
    const option = (option, optionValue) => {
      if (typeof option === 'undefined') {
        return props;
      } else if (typeof option === 'string') {
        if (typeof optionValue === 'undefined') return props[option];else setOptions({
          [option]: optionValue
        });
      } else if (typeof option === 'object') {
        setOptions({
          ...options,
          ...option
        });
      }
    };
    useEffect(() => {
      setOptions({});
    }, [props]);
    return jsx(WrappedComponent, {
      ...props,
      ...options,
      action: {
        option
      },
      ref: ref,
      css: sx(props === null || props === void 0 ? void 0 : props.sx)
    });
  });
};
export default OptionWrapper;